import Organization from "../../models/organization";
export const state = {
	organization: new Organization({}),
};
